// Nav items shared by the individual and org side menus
import { PaymentDropoffIcon } from '@icons';
import {
  DashboardIcon,
  EventsIcon,
  FormsIcon,
  GroupsIcon,
  MembersIcon,
  OrgSettingsIcon,
  QuickCollectIcon,
  ReportsIcon,
  SubscriptionIcon,
  TransactionsIcon
} from '@images';

import {
  DASHBOARD,
  EVENTS,
  FORMS,
  GROUPS,
  MEMBERS,
  ORG_SETTINGS,
  PAYMENT_DROPOFFS,
  QUICK_COLLECT,
  REPORTS,
  SUBSCRIPTIONS,
  TRANSACTIONS
} from '@constants/routes';

import { FEATURE_FLAGS } from './feature';
import UserPermissionTypes from './permissions';

export const DASHBOARD_ITEM = {
  id: 'dashboard',
  Icon: DashboardIcon,
  label: 'Dashboard',
  route: DASHBOARD,
  permissions: [UserPermissionTypes.DASHBOARD_VIEW]
};

export const MEMBERS_ITEM = {
  id: 'members',
  Icon: MembersIcon,
  label: 'Members',
  route: MEMBERS.MEMBERS,
  permissions: [UserPermissionTypes.BRANCH_MEMBER_VIEW]
};

export const GROUPS_ITEM = {
  id: 'groups',
  Icon: GroupsIcon,
  label: 'Groups',
  route: GROUPS.HOME,
  permissions: [UserPermissionTypes.GROUP_VIEW]
};

export const QUICK_COLLECT_ITEM = {
  id: 'quick-collect',
  Icon: QuickCollectIcon,
  label: 'Quick Collect',
  route: QUICK_COLLECT.CREATE_LINK,
  permissions: [UserPermissionTypes.PAYMENT_ORDER_CREATE]
};

export const TRANSACTIONS_ITEM = {
  id: 'transactions',
  Icon: TransactionsIcon,
  label: 'Transactions',
  route: TRANSACTIONS.TRANSACTIONS,
  permissions: [UserPermissionTypes.PAYMENT_ORDER_VIEW]
};

export const PAYMENT_DROPOFFS_ITEM = {
  id: 'payment-dropoffs',
  Icon: PaymentDropoffIcon,
  label: 'Payment dropoffs',
  route: PAYMENT_DROPOFFS.HOME,
  permissions: [UserPermissionTypes.PAYMENT_ORDER_VIEW],
  featureFlag: FEATURE_FLAGS.PAYMENT_DROP_OFF_DASHBOARD,
  isBeta: true
};

export const EVENTS_ITEM = {
  id: 'event-registration',
  Icon: EventsIcon,
  label: 'Events',
  route: EVENTS.HOME,
  permissions: [UserPermissionTypes.EVENT_VIEW]
};

export const FORMS_ITEM = {
  id: 'forms',
  Icon: FormsIcon,
  label: 'Forms',
  route: FORMS.HOME,
  permissions: [UserPermissionTypes.FORM_VIEW],
  featureFlag: FEATURE_FLAGS.FORMS
};

// Any one of these grants access to the org and branch reports pages
export const REPORT_PERMISSIONS = [
  UserPermissionTypes.PAYMENT_ORDER_GENERATE_GST_REPORT,
  UserPermissionTypes.PAYMENT_ORDER_GENERATE_CUSTOM_REPORT,
  UserPermissionTypes.AUDIT_LOG_VIEW
];

export const REPORTS_ITEM = {
  id: 'report',
  Icon: ReportsIcon,
  label: 'Reports',
  route: REPORTS,
  permissions: REPORT_PERMISSIONS
};

export const ORG_SETTINGS_ITEM = {
  id: 'org-settings',
  Icon: OrgSettingsIcon,
  label: 'Configurations',
  route: ORG_SETTINGS,
  permissions: [
    UserPermissionTypes.SUBSCRIPTION_VIEW,
    UserPermissionTypes.INTEGRATION_EDIT
  ]
};

export const SUBSCRIPTIONS_ITEM = {
  id: 'subscriptions',
  Icon: SubscriptionIcon,
  label: 'Plan & Billing',
  route: SUBSCRIPTIONS.PLAN_DETAILS,
  permissions: [UserPermissionTypes.SUBSCRIPTION_VIEW]
};
